(exports.GAME_ID = "5f34e4ec6f609a00179ed677"),
(exports.FORM_ID = "5f34e5666f609a00179ed678"),
(exports.STATUS_FORM_ID = "604098955f01640015a8f8f1"),
(exports.SERVER_URL = "https://api-gabarit.promo.dev"),
(exports.BD_NAME = "jeu-dev");